module.exports = __webpack_public_path__ + "src/app/images/destination_reached.svg";